import React, { useState } from 'react';
import './notificationFullView.scss';
import './notifications.scss';
import Notifications from './notifications';


const NotificationFullView = () => {
  const [selectedNotification, setSelectedNotification] = useState(null);

  const notificationsTitleStyle = {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '100%',
    letterSpacing: '0px',
    fontFamily: 'Mukta',
    color: '#7A757F',

  };

  return (
    <div className="notification-detail-outer-layer">
      <div className="users-manage-outer-layere">
        <div className="users-manage-title">Notification</div>
        <div className="notification-detail-container">
          <div className="notification-list-pane">
            <Notifications
              onSelect={setSelectedNotification}
              selected={selectedNotification}
              title="All Notifications"
              titleStyle={notificationsTitleStyle}
            />
          </div>
          <div className="notification-fullview-pane">
            {selectedNotification ? (
              <div className="notification-fullview-card">
                <div className="notification-fullview-header notification-fullview-header--row">
                  <span className="notification-fullview-badge">{selectedNotification.status}</span>
                  <div className="notification-fullview-date-new">
                    <span className="notification-fullview-date">{selectedNotification.date}</span>
                    {selectedNotification.isNew && <span className="notification-fullview-new">New</span>}
                  </div>
                </div>
                <div className="notification-fullview-title">
                  {selectedNotification.dealId}
                  {selectedNotification.badge && (
                    <span className="notification-fullview-title-badge">
                      {selectedNotification.badge}
                    </span>
                  )}
                </div>
                <div className="notification-fullview-desc">{selectedNotification.description}</div>
                {selectedNotification.extra && (
                  <div className="notification-fullview-extra">{selectedNotification.extra}</div>
                )}
                <div className="notification-fullview-placeholder-border" />
              </div>
            ) : (
              <>
                <div className="notification-fullview-placeholder">
                  Select a notification to view details
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationFullView;
